import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

// ── MSAL Configuration ──
// IT Team: Replace these values with your Azure AD App Registration details
const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'YOUR_CLIENT_ID',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'YOUR_TENANT_ID'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes required by the application
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

// Scopes for Graph API calls (SharePoint, email)
export const graphScopes = {
  scopes: ['Files.ReadWrite.All', 'Sites.ReadWrite.All', 'Mail.Send'],
};

// API scope for backend
export const apiScopes = {
  scopes: [`api://${msalConfig.auth.clientId}/access_as_user`],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Helper to get access token for API calls
export async function getAccessToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    throw new Error('No accounts found. Please sign in.');
  }

  // Try custom API scope first, fall back to User.Read (Graph) scope
  // The backend validates RSA signature + issuer, not audience, so either works
  const scopesToTry = [apiScopes, loginRequest];

  for (const scopeConfig of scopesToTry) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        ...scopeConfig,
        account: accounts[0],
      });
      return response.accessToken;
    } catch (err) {
      // Try next scope
    }
  }

  // Last resort: interactive popup with login scopes
  const response = await msalInstance.acquireTokenPopup(loginRequest);
  return response.accessToken;
}

export default msalConfig;
